import { message } from 'antd';
import * as API from '@/services/api';

export default {
  namespace: 'department',
  state: {
    depParentList: [],
    depList: [],
    depInfo: {},
    comInfoNew: {},
    memList: [],
  },
  effects: {
    *getDepList({ payload }, { call, put }) {
      const res = yield call(API.getDepList, { ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            depList: data.dep_list,
            depParentList: data.dep_parent_list,
            memList: data.mem_list,
          },
        });
      }
    },
    *getDepDetail({ payload }, { call, put }) {
      const res = yield call(API.detailDep, { ...payload });
      if (res.code === 0) {
        const data = res.data;
        yield put({
          type: 'save',
          payload: {
            depInfo: data
          },
        });
      }
    },
    *addDep({ payload }, { call, put }) {
      const res = yield call(API.addDep, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getDepList',
        });
      } else {
        message.error(res.message);
      }
    },
    *editDep({ payload }, { call, put }) {
      const res = yield call(API.editDep, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getDepList',
        });
        yield put({
          type: 'save',
          payload: {depInfo: res.data}
        })
      } else {
        message.error(res.message);
      }
    },
    *delDep({ payload }, { call, put }) {
      const res = yield call(API.delDep, payload);
      if (res.code === 0) {
        message.success('OK');
        yield put({
          type: 'getDepList',
        });
      } else {
        message.error('存在子部门或成员');
      }
    },
  },
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};
